import PostEditor from '@/components/PostEditor'
import { cn } from '@/lib/utils'
import { canWriteAtom } from '@/atoms/session'
import { HugeiconsIcon } from '@hugeicons/react'
import { QuillWrite01Icon } from '@hugeicons/core-free-icons'
import { useState } from 'react'
import SidebarItem from './SidebarItem'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'

export default function PostButton({ collapse }: { collapse: boolean }) {
  const canWrite = useAtomValue(canWriteAtom)
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  if (!canWrite) return null

  return (
    <div className="pt-4 mb-2">
      <SidebarItem
        title={t('Publish something')}
        description={t('New note')}
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
        variant="default"
        className={cn('bg-primary gap-2', !collapse && 'justify-center')}
        collapse={collapse}
      >
        <HugeiconsIcon icon={QuillWrite01Icon} />
      </SidebarItem>
      <PostEditor open={open} setOpen={setOpen} />
    </div>
  )
}
